import {useAppSelector} from '@/hooks';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';
import type {TranscriptItemObject} from '@PosterWhiteboard/items/transcript-item/transcript-item.types';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {FillObject} from '@PosterWhiteboard/classes/fill.class';

export function useGetKeyFromSubtitleBackgroundFillPropertiesForActiveTranscriptItem<T extends keyof FillObject>(key: T): FillObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const itemObject = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];
    if (!itemObject) {
      return undefined;
    }

    if (itemObject.gitype !== ITEM_TYPE.TRANSCRIPT) {
      throw new Error(`Item isn't a transcript item`);
    }

    const transcriptItemObject = itemObject as TranscriptItemObject;
    const anySubtitleBackgroundFillObject = Object.values(transcriptItemObject.subtitlesHashmap)[0].backgroundFill;

    if (anySubtitleBackgroundFillObject[key] !== undefined) {
      return anySubtitleBackgroundFillObject[key];
    }

    return undefined;
  });
}
